import React from 'react';
import ReactDOM from 'react-dom/client';
import ManagerPortalLayout from './components/layouts/ManagerPortalLayout';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ManagerPortalLayout />
  </React.StrictMode>
);